// Main branch entry point - NO PROJECT CONTENT
// This file is used for builds that should not include project pages

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './styles/variables.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { DensityProvider } from './contexts/DensityContext.js';
import { RecruiterModeProvider } from './contexts/RecruiterModeContext.js';
import { HiringNotesProvider } from './contexts/HiringNotesContext.js';
import {
    Loop,
    Medication,
    Engagement,
    Healers,
    AboutPageWrapper,
} from './pages/lazy-studies.js';
import ScrollToTop from './components/scrolltotop.js';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <RecruiterModeProvider>
        <DensityProvider>
          <HiringNotesProvider>
            <ScrollToTop />
            <Suspense fallback={null}>
            <Routes>
            <Route path="/" element={<App />} />
            <Route path="/about" element={<AboutPageWrapper />} />
            <Route path="/loop" element={<Loop />} />
            <Route path="/medication" element={<Medication />} />
            <Route path="/engagement" element={<Engagement />} />
            <Route path="/healers" element={<Healers />} />
            
            {/* No project routes in main - users cannot access project pages */}
          </Routes>
            </Suspense>
            </HiringNotesProvider>
        </DensityProvider>
      </RecruiterModeProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
